import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Aluno } from 'src/app/core/aluno';
import { TiposPublicoPrioritario } from 'src/app/core/tipos-publico-prioritario';
import { TiposPublicoPrioritarioService } from 'src/app/services/tipos-publico-prioritario/tipos-publico-prioritario.service';

@Component({
  selector: 'combo-tipos-publicos-prioritarios',
  templateUrl: './combo-tipos-publicos-prioritarios.component.html',
  styleUrls: ['./combo-tipos-publicos-prioritarios.component.css']
})
export class ComboTiposPublicosPrioritariosComponent implements OnInit, OnChanges {

  @Input() aluno: Aluno;
  @Input() obrigatorio = false;
  @Input() multiplaSelecao = true;
  @Input() showDisplayId = false;
  @Input() label = 'Tipos de públicos prioritários';

  @Output() valorChange = new EventEmitter<TiposPublicoPrioritario[]>();

  tiposPublicosPrioritarios: TiposPublicoPrioritario[] = [];

  constructor(private tiposPublicoPrioritarioService: TiposPublicoPrioritarioService) {
  }

  ngOnInit(): void {
    this.inicializarSelecao();

    this.tiposPublicoPrioritarioService.getAll()
      .subscribe((tipos: TiposPublicoPrioritario[]) => {
        this.tiposPublicosPrioritarios = tipos || [];
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.aluno) {
      this.inicializarSelecao();
    }
  }

  onValorChange(tiposSelecionados: TiposPublicoPrioritario[]): void {
    if (!this.aluno) {
      return;
    }

    this.aluno.tiposPublicosPrioritarios = tiposSelecionados || [];
    this.valorChange.emit(this.aluno.tiposPublicosPrioritarios);
  }

  private inicializarSelecao(): void {
    if (this.aluno && !Array.isArray(this.aluno.tiposPublicosPrioritarios)) {
      this.aluno.tiposPublicosPrioritarios = [];
    }
  }
}
